import inviteService from '@/api/invite'
import errorhandler from '@/utils/errorhandler.js'
import { INVITE } from '../types'

export default{
  namespaced: true,
  state:{
    guests: [],
    guestTeams: []
  },
  mutations:{
    [INVITE.REMOVE_GUEST] (state, employee) {
      const index = state.guests.findIndex(e => e.id === employee.id)
      state.guests.splice(index, 1);
    },
    [INVITE.ADD_GUEST] (state, employee) {
      state.guests.push(employee)
    },
    [INVITE.REMOVE_GUEST_TEAMS] (state, team) {
      const index = state.guestTeams.findIndex(t => t.id === team.id)
      state.guestTeams.splice(index, 1);
    },
    [INVITE.ADD_GUEST_TEAMS] (state, team) {
      state.guestTeams.push(team)
    },
    [INVITE.CLEAR_GUESTS] (state) {
      state.guestTeams = [];
      state.guests = [];
    }
  },
  actions:{
    async create({dispatch, state}, obj)
    {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const invite = {
          title: obj.title,
          description: obj.description,
          start: obj.start,
          finish: obj.finish,
          desks: obj.desks,
          employees: state.guests.map(g => g.id),
          teams: state.guestTeams.map(g => g.id)
        }

        const response = await inviteService.create(invite, obj.locationId)
        return response.data
      }
      catch(response){
        errorhandler.handleError(response)
        return Promise.reject(response)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    uninviteGuest({commit, state}, employee){
      if(state.guests.some(e => e.id === employee.id)){
        commit(INVITE.REMOVE_GUEST, employee)
      }
    },
    inviteEmployee({commit, state}, employee){
      if(!state.guests.some(e => e.id === employee.id)){
        commit(INVITE.ADD_GUEST, employee)
      }
    },
    uninviteTeam({commit, state}, team){
      if(state.guestTeams.some(e => e.id === team.id)){
        commit(INVITE.REMOVE_GUEST_TEAMS, team)
      }
    },
    inviteTeam({commit, state}, team){
      if(!state.guestTeams.some(e => e.id === team.id)){
        commit(INVITE.ADD_GUEST_TEAMS, team)
      }
    },
    clearGuests({commit}){
      commit(INVITE.CLEAR_GUESTS)
    }
  }
}
